import { Container, ContentHeader, Page } from 'components'
import { ChurnCreateForm } from './components'

const ChurnsCreate = () => {
  return (
    <Page title="Criação de solicitação de churn">
      <Container maxWidth={false}>
        <ContentHeader
          menu="Solicitações de churns"
          title="Criação"
          subtitle="Solicitação de churn"
        />
        <ChurnCreateForm />
      </Container>
    </Page>
  )
}

export default ChurnsCreate
